import { render, staticRenderFns } from "./visual-reporting-chart.vue?vue&type=template&id=27c71e7a"
import script from "./visual-reporting-chart.vue?vue&type=script&lang=js"
export * from "./visual-reporting-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports